import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  BasketItem,
  EnterpriseSearchService,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import { LoungesEnterpriseSearchInterface, TerminalsType } from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-basket-lounge',
  templateUrl: './basket-lounge.component.html',
  styleUrls: ['./basket-lounge.component.scss'],
  standalone: false
})
export class BasketLoungeComponent implements OnInit {
  @Input() lounge: BasketItem;
  @Input() duplicateBooking = false;
  @Input() itemIndex = 0;
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChangeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() displayItinerary = false;

  public searchParameters: LoungesEnterpriseSearchInterface = null;
  travellers = [];

  constructor(private searchService: EnterpriseSearchService) {}

  ngOnInit() {
    this.searchParameters = this.searchService.searches[ServiceType.Lounge];
    this.travellers = [...(this.lounge?.users || []), ...(this.lounge?.guests || [])];
  }

  getTerminal(terminal: string) {
    if (terminal) {
      const newTerminals: TerminalsType[] = this.searchService.processTerminals([terminal]);
      if (newTerminals.length > 1) {
        return this.searchService.processTerminals([terminal])[1]?.key;
      } else {
        return this.searchService.processTerminals([terminal])[0]?.key;
      }
    } else {
      return 'Any Terminal';
    }
  }
}
